// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostImage-cls1___046b29a9b407174ec9c{/*!*/}.PostImage-cls2__dd0fdd974c74348ae7c7{width:100%;background-repeat:no-repeat;background-size:contain;background-position:center;cursor:pointer}.PostImage-cls2__dd0fdd974c74348ae7c7.PostImage-border___07a50361f88a696b231{border:1px solid #dddde2;border-radius:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PostImage-cls1___046b29a9b407174ec9c",
	"cls2": "PostImage-cls2__dd0fdd974c74348ae7c7 PostImage-cls1___046b29a9b407174ec9c",
	"border": "PostImage-border___07a50361f88a696b231"
};
export default ___CSS_LOADER_EXPORT___;
